import FontAwesome from "@expo/vector-icons/build/FontAwesome";
import React from "react";
import { View, TouchableOpacity, Text } from "react-native";
import SelectMonth from "../filter/SelectMonth";
import { CommonReload } from "../filter/CommonReload";

export function WorkDBHeader(props: any) {
  return (
    <View style={{ flexDirection: "row", alignItems: "center" }}>
      <CommonReload />
    </View>
  );
}
